module.exports = __webpack_public_path__ + "img/540-42dfb3.png";